import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

// State
import { Provider, useDispatch } from 'react-redux';
import store from 'src/react/recommendations/store';
import { setInitialView } from 'src/react/recommendations/store/slices/view';
import { setIdeas } from 'src/react/recommendations/store/slices/ideas';
import {
  setCompleted,
  setUncompleted
} from 'src/react/recommendations/store/slices/tasks';
import {
  setSurveyCompleted,
  setSurveyPath
} from 'src/react/recommendations/store/slices/settings';

// Components
import RecommendationLayout from 'src/react/recommendations/Layout';

// Style
import 'src/react/recommendations.scss';

const recommendationsPropTypes = {
  defaultEnabledView: PropTypes.string,
  ideas: PropTypes.array,
  uncompletedTasks: PropTypes.array,
  completedTasks: PropTypes.array,
  surveyPath: PropTypes.string,
  isSurveyComplete: PropTypes.bool
};

const Recommendations = (props) => {
  const { defaultEnabledView, isSurveyComplete, surveyPath } = props;
  const initialIdeas = props?.ideas || [];
  const initialUncompletedTasks = props?.uncompletedTasks || [];
  const initialCompletedTasks = props?.completedTasks || [];

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(setInitialView(defaultEnabledView));
    dispatch(setIdeas(initialIdeas));
    dispatch(setUncompleted(initialUncompletedTasks));
    dispatch(setCompleted(initialCompletedTasks));
    dispatch(setSurveyPath(surveyPath));
    dispatch(setSurveyCompleted(isSurveyComplete));
  }, [defaultEnabledView]);

  return <RecommendationLayout />;
};
Recommendations.propTypes = recommendationsPropTypes;

const RecommendationsWithProvider = (props) => (
  <Provider store={store}>
    <Recommendations {...props} />
  </Provider>
);
RecommendationsWithProvider.propTypes = recommendationsPropTypes;

export default RecommendationsWithProvider;
